import { QuestionVisibilityState } from "@/components/survey/Question";

import { isB2CPartner } from "../partners";

export function shouldShowWomensHealthQuestions({
  partnerInfo,
  surveyAnswers: { sex },
}: QuestionVisibilityState) {
  return (
    ["female", "intersex"].includes(sex ?? "") && !isB2CPartner(partnerInfo)
  );
}
